import { FormValidation } from '../../js/libraries/validation';
export class ContactFooter {

    constructor() {
        this.formSimple = document.querySelector('.contact-footer form');
        this.popup = document.querySelector('.subscribe-popup');
        this.formExtended = this.popup.querySelector('form');

        if(this.formSimple !== null && this.formExtended !== null) {
            this.initialiseForms();
        }
    }

    initialiseForms() {
        this.formSimpleValidator = new FormValidation(this.formSimple);

        this.formSimple.addEventListener('submit', e => {
            e.preventDefault();

            if (this.formSimpleValidator.validateFields()) {
                let simpleEmailField = this.formSimple.querySelector('input[name="EMAIL"]'),
                    extendedEmailField = this.formExtended.querySelector('input[name="EMAIL"]');


                extendedEmailField.value = simpleEmailField.value;
                this.popup.classList.remove('hide');
            }
        });

        this.popup.addEventListener('click', e => {
            if(e.toElement === this.popup) {
                this.popup.classList.add('hide');
            }
        });
    }
}


// WEBPACK FOOTER //
// ./assets/sass/shared/contact-footer.js